/****************************************************
 * Module Name:  packetRemark.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import Constants from "../../utility/constants";
import Select from "react-select";
import "bootstrap/dist/css/bootstrap.min.css";
import { Box, Button, TextField } from "@mui/material";
import CommonSnackbar from "../common/commonSnackBar";
import RemarkProxy from "../../utility/proxy/manager/manufacturingProxy/remarkProxy";
import { LoadingButton } from "@mui/lab";
import SaveIcon from '@mui/icons-material/Save';
import logo from '../../images/pansuriya.jpg'

export default class PacketRemark extends Component {
    constructor(props) {
        super(props);

        this.state = {
            newRemarkCategory: "",
            newdescription: "",
            showError: false,
            showApiError: false,
            categoryOptions: [],
            showCategoryLoadSpinner: true,
            showValidationMessage: false,
        };
        this.getAllcategory(false);
    }

    getAllcategory = (bAnimateSpinner) => {
        bAnimateSpinner && this.setState({ showCategoryLoadSpinner: true });
        RemarkProxy.GetAllRemarkMini((response) => {
            if (response) {
                this.setAllCategoryData(response)
            } else {
                this.setState({ showApiError: true, showCategoryLoadSpinner: false, })
            }
        }
        );
    };

    setAllCategoryData = (response) => {
        let optionsArray = [];
        response.map((data) => {
            let option = {
                value: data.id,
                label: data.id + " | " + data.category,
            };
            optionsArray.push(option);

            return true;
        });
        this.setState({
            categoryOptions: optionsArray,
            newRemarkCategory: optionsArray[0],
            showCategoryLoadSpinner: false,
        });
    };


    handleSave = () => {
        let data = {
            kapanid: this.props.kapanId,
            packetid: this.props.packetId,
            remark: this.state.newdescription,
            userid: Constants.loggedInUser.id,
            remark_category_id: this.state.newRemarkCategory.value,
            departmentid: this.props.sourceData.department_id
        };

        if (this.props.handleSave) {
            if (this.props.handleValidation) {
                if (this.props.handleValidation(data))
                    this.props.handleSave(data);
                else
                    this.setState({
                        showError: true,
                    });
            } else this.props.handleSave(data);
        }
    };

    closeErrorDialog = () => {
        this.setState({
            showError: false,
            showApiError: false
        });
    };

    render() {
        return (
            <Box>
                <CommonSnackbar
                    show={this.state.showError}
                    message={
                        <Box>
                            Add Packet Remark validation Failed
                            <br /> Please enter complete data
                        </Box>
                    }
                    variant={"error"}
                    autoHide={false}
                    handleClose={this.closeErrorDialog}
                    title="Validation Failure"
                />
                <CommonSnackbar
                    show={this.state.showApiError}
                    message={
                        <Box>
                            {Constants.APiFailErrorMessage}
                        </Box>
                    }
                    variant={"error"}
                    autoHide={false}
                    handleClose={this.closeErrorDialog}
                    title="Failed"
                />

                <Modal backdrop="static" show={this.props.Show} onHide={this.props.handleClose} enforceFocus={false}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <img
                                src={logo}
                                height="40pt"
                                width="40pt"
                                alt={Constants.COMPANY_SITE}
                            />
                            &nbsp;&nbsp;
                            Add New Remark
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <center>
                            <table style={{ width: "100%" }}>
                                <tbody>
                                    <tr>
                                        <td>
                                            <Form.Label>Remark Category <sup style={{ color: "red" }}>*</sup></Form.Label>
                                        </td>
                                        <td>
                                            <Select menuPlacement="auto"
                                                blurInputOnSelect={false}
                                                getOptionLabel={(option) => option.label}
                                                getOptionValue={(option) => option.value}
                                                value={this.state.newRemarkCategory}
                                                isSearchable={true}
                                                closeMenuOnSelect={true}
                                                name="Remark Category"
                                                menuPortalTarget={document.body}
                                                styles={Constants.Styles}
                                                options={this.state.categoryOptions}
                                                onChange={(selectedOption) =>
                                                    this.setState({
                                                        newRemarkCategory: selectedOption,
                                                    })
                                                }
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Label>Remark<sup style={{ color: "red" }}>*</sup></Form.Label>
                                        </td>
                                        <td>
                                            <TextField
                                                margin="normal"
                                                size="small"
                                                fullWidth
                                                multiline
                                                label="Remark"
                                                placeholder="Enter Remark"
                                                value={this.state.newdescription}
                                                onChange={(e) =>
                                                    this.setState({
                                                        newdescription: e.target.value,
                                                    })
                                                }
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>&nbsp;</td>
                                    </tr>
                                </tbody>
                            </table>
                        </center>
                    </Modal.Body>
                    <Modal.Footer>
                        <LoadingButton
                            loading={this.props.loading}
                            loadingPosition="start"
                            startIcon={<SaveIcon />}
                            variant="contained"
                            onClick={() => this.handleSave()}
                            disabled={(!this.state.newRemarkCategory || this.state.newdescription <= 0) ? true : false}
                            sx={{ mr: 1 }}
                        >
                            Save
                        </LoadingButton>
                        <Button
                            variant="contained"
                            color="error"
                            onClick={this.props.handleClose}
                            disabled={this.props.loading}
                        >
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Box>
        );
    }
}
